import {
  IClientDetails,
  IClientExpertise,
  IClientMapSnippet,
  IClientProjects,
  IClientSnapshot,
  IClientStoriesAndHighlights,
} from 'app/components/DetailsPages/interfaces/client';

import { http } from './http';

//Params
interface IClientDetailsParams {
  slug: string;
}

//Details
export const getClientDetails = (slug: string) => {
  return http.get<IClientDetails>(`client/${slug}/details`);
};

export const getClientSnapshot = (slug: string) => {
  return http.get<IClientSnapshot>(`client/${slug}/details/snapshot`);
};

export const getClientExpertise = (slug: string) => {
  return http.get<IClientExpertise>(`client/${slug}/details/expertise`);
};

export const getClientProjects = (slug: string, params: any) => {
  return http.get<IClientProjects>(`client/${slug}/details/projects`, params);
};

export const getClientMapSnippet = (slug: string) => {
  return http.get<IClientMapSnippet>(`client/${slug}/details/map_snippet`);
};

export const getClientStoriesAndHighlights = (slug: string) => {
  return http.get<IClientStoriesAndHighlights>(`client/${slug}/details/stories_and_highlights`);
};

export const getClientSummary = (slug: string) => {
  return http.get<any>(`client/${slug}/details/summary`);
};

//Drawers
export const getClientProjectsDrawer = (slug: string, params: any) => {
  return http.get<any>(`client/${slug}/drawers/projects`, params);
};

export const getClientPeopleDrawer = (slug: string, params: any) => {
  return http.get(`client/${slug}/drawers/people`, params);
};

export const getClientCompaniesDrawer = (slug: string) => {
  return http.get(`client/${slug}/drawers/companies`);
};
